module.exports = __webpack_public_path__ + "static/media/close-24px.693a2934.svg";